import * as types from "../types/complementos";

const INITIAL_STATE = {
  filtro: {
    titulo: "",
  },
  page: 1,
  perpage: 10,
  total: 0,
  complementos: [],
  complemento: {},
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_COMPLEMENTO:
      return { ...state, complemento: action.payload };
    case types.LOAD_COMPLEMENTOS:
      return { ...state, complementos: action.payload };
    case types.SET_PAGE_COMPLEMENTO:
      return { ...state, page: action.payload };
    case types.SET_PERPAGE_COMPLEMENTO:
      return { ...state, perpage: action.payload };
    case types.SET_TOTAL_COMPLEMENTO:
      return { ...state, total: action.payload };
    case types.LOADING_COMPLEMENTO:
      return { ...state, loading: action.payload };
    case types.SET_FILTRO_COMPLEMENTO:
      return {
        ...state,
        filtro: { ...state.filtro, ...action.payload },
      };
    default:
      return state;
  }
};
